import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px',
    backgroundColor: '#f50057',
    '&:hover': {
      backgroundColor: '#c51162'
    }
  }
};

const enhance = compose();

const button = enhance(
  ({
    classes,
    onClickAction,
    title,
    disabled = false,
    className,
    secondary = false
  }) => {
    return (
      <Button
        variant="contained"
        color={secondary ? 'secondary' : 'primary'}
        disabled={disabled}
        onClick={onClickAction}
        className={`${classes.button} ${className}`}
      >
        {title}
      </Button>
    );
  }
);

export default withRouter(withStyles(styles)(button));
